import { Tree as AntdTree } from 'antd';

// Re-exported, not wrapped: the rows are theme config (`treeRowTokens` in constants/antd.constants.ts), and
// wrapping would drop the generic node type and the statics. A searchable checklist is SelectedTree, a single
// pick SingleSelectionTree, and a picker in a popover PopoverTreeSelector.
export const Tree = AntdTree;

export default Tree;
